import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center p-8">
            <p className="text-lg text-[#A3A3A3] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Что-то пошло не так
            </p>
            <button
              data-testid="error-retry"
              onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
              className="text-sm text-[#D4AF37] border border-[#D4AF37]/30 px-6 py-2 hover:bg-[#D4AF37]/10 transition-colors"
            >
              Попробовать снова
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export function SkeletonCard() {
  return (
    <div className="bg-white/[0.04] border border-white/[0.08] rounded-lg overflow-hidden animate-pulse">
      <div className="aspect-video bg-white/[0.06]" />
      <div className="p-5 space-y-3">
        <div className="h-4 bg-white/[0.06] rounded w-3/4" />
        <div className="h-5 bg-white/[0.06] rounded w-1/2" />
        <div className="flex gap-2">
          <div className="h-6 bg-white/[0.06] rounded w-16" />
          <div className="h-6 bg-white/[0.06] rounded w-20" />
        </div>
        <div className="h-9 bg-white/[0.06] rounded w-full mt-2" />
      </div>
    </div>
  );
}

export function SkeletonList({ count = 3 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white/[0.04] border border-white/[0.08] rounded-md p-4 flex gap-4 animate-pulse">
          <div className="w-16 h-16 bg-white/[0.06] rounded flex-shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-white/[0.06] rounded w-3/4" />
            <div className="h-3 bg-white/[0.06] rounded w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonText({ lines = 3 }) {
  return (
    <div className="space-y-2 animate-pulse">
      {Array.from({ length: lines }).map((_, i) => (
        <div key={i} className={`h-3 bg-white/[0.06] rounded ${i === lines - 1 ? "w-2/3" : "w-full"}`} />
      ))}
    </div>
  );
}
